import { AllFeatureIds } from 'generated/featureIds.generated'

export const TimeoffFeatureFlags = {
  TIMEOFF_MINUTE_BLOCK_ROUNDING: 'timeoff_minute_block_rounding',
  DEV_TIMEOFF_COUNT_REST_DAYS_OPTION: 'dev_timeoff_count_rest_days_option',
  TIMEOFF_LEAVES_APPROVAL_RECOMMENDATION: 'timeoff_leaves_approval_recommendation',
} as const satisfies Record<string, AllFeatureIds>
